(function () {
    var gs = document.getElementById('gs');
    if (gs) { gs.style.top = '86px'; }
})();


document.addEventListener('DOMContentLoaded', function() {
    var siteControl = document.getElementById('site-control');
    if (!siteControl) return;
    siteControl.addEventListener('click', function() {
        this.classList.toggle('clicked-menu');
    });
});


var armorspec = document.getElementById('armorspec');
if (armorspec) armorspec.addEventListener('click', function (e) {
    /* 阻止 href="#" 先跳到页顶，切换后直接定位到规格区，避免页面上下跳动 */
    e.preventDefault();
    var featurescontent = document.getElementById('featurescontent');
    var speccontent = document.getElementById('speccontent');
    if (featurescontent) featurescontent.style.display = 'none';
    if (speccontent) speccontent.style.display = 'block';
    armorspec.classList.add('active-button');
    var features = document.getElementById('features');
    if (features) features.classList.remove('active-button');
    document.querySelectorAll('.faq_nav .wide').forEach(function (el) {
        el.style.display = '';
    });
    if (!speccontent) return;
    /* 动态计算顶部固定栏（主菜单 + 产品子导航）的实际底部位置，避免规格区顶部被遮住 */
    function headerBottom() {
        var bottom = 0;
        ['site-control', 'faq_nav'].forEach(function (id) {
            var el = document.getElementById(id);
            if (!el) return;
            var pos = getComputedStyle(el).position;
            if (pos !== 'fixed' && pos !== 'sticky') return;
            var r = el.getBoundingClientRect();
            if (r.height > 0 && r.bottom > bottom) bottom = r.bottom;
        });
        return bottom || 60;
    }
    var gap = 10;
    var targetTop = speccontent.getBoundingClientRect().top + window.pageYOffset - headerBottom() - gap;
    window.scrollTo({ top: targetTop > 0 ? targetTop : 0, behavior: 'instant' });
    /* 滚动后固定栏状态可能变化，再校正一次 */
    requestAnimationFrame(function () {
        var diff = speccontent.getBoundingClientRect().top - headerBottom() - gap;
        if (Math.abs(diff) > 1) window.scrollBy({ top: diff, behavior: 'instant' });
    });
});
